import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed } from 'vue';
import CollageTileDefaultLayoutTextAndLink
    from '@/shared/content/blocks/collage-layouts/default-layout-helpers/CollageTileDefaultLayoutTextAndLink.vue';
import CollageTileDefaultLayoutMediaWithLink
    from '@/shared/content/blocks/collage-layouts/default-layout-helpers/CollageTileDefaultLayoutMediaWithLink.vue';
import { TileContentModel } from '@/types/B2BcontentServerContract';


export default /*#__PURE__*/_defineComponent({
  __name: 'CollageTileDefaultLayoutGridOptionA',
  props: {
    tileModelData: null,
    mirrorGrid: { type: Boolean },
    isFirstOrLast: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as { tileModelData: TileContentModel, mirrorGrid: boolean, isFirstOrLast: boolean }



const aspectRatio = (aspectRatio: number) => {
    const padding: string = `${(100 / aspectRatio).toFixed(2)}%`;
    return { paddingTop: padding };
};

const aspectRatioFirstItem = computed(() => {
    return {
        'max-sm': props.isFirstOrLast ? 1000 / 1112 : 100 / 111,
        'max-md': props.isFirstOrLast ? 1000 / 1032 : 100 / 111,
        default: props.isFirstOrLast ? 1000 / 1032 : 100 / 109,
    };
});

const aspectRatioSecondItem = computed(() => {
    return { default: 200 / 105 };
});

const aspectRatioThirdItem = computed(() => {
    return { default: 100 / 105 };
});

const firstItem = computed(() => {
    return props.mirrorGrid ? props.tileModelData[2] : props.tileModelData[0];
});

const secondItem = computed(() => {
    return props.mirrorGrid ? props.tileModelData[0] : props.tileModelData[1];
});

const thirdItem = computed(() => {
    return props.mirrorGrid ? props.tileModelData[1] : props.tileModelData[2];
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["grid-layout", { 'isFirstOrLast': __props.isFirstOrLast }])
  }, [
    (_unref(firstItem))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["item-1 relative", { 'item-1--mirrored': __props.mirrorGrid }]),
          style: _normalizeStyle(aspectRatio(_unref(aspectRatioFirstItem)))
        }, [
          _createVNode(CollageTileDefaultLayoutMediaWithLink, {
            data: _unref(firstItem),
            "aspect-ratio": _unref(aspectRatioFirstItem)
          }, null, 8, ["data", "aspect-ratio"]),
          _createVNode(CollageTileDefaultLayoutTextAndLink, { data: _unref(firstItem) }, null, 8, ["data"])
        ], 6))
      : _createCommentVNode("", true),
    (_unref(secondItem))
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["item-2 relative", { 'item-2--mirrored': __props.mirrorGrid }]),
          style: _normalizeStyle(aspectRatio(_unref(aspectRatioSecondItem)))
        }, [
          _createVNode(CollageTileDefaultLayoutMediaWithLink, {
            data: _unref(secondItem),
            "aspect-ratio": _unref(aspectRatioSecondItem)
          }, null, 8, ["data", "aspect-ratio"]),
          _createVNode(CollageTileDefaultLayoutTextAndLink, { data: _unref(secondItem) }, null, 8, ["data"])
        ], 6))
      : _createCommentVNode("", true),
    (_unref(thirdItem))
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: _normalizeClass(["item-3 relative", { 'item-3--mirrored': __props.mirrorGrid }]),
          style: _normalizeStyle(aspectRatio(_unref(aspectRatioThirdItem)))
        }, [
          _createVNode(CollageTileDefaultLayoutMediaWithLink, {
            data: _unref(thirdItem),
            "aspect-ratio": _unref(aspectRatioThirdItem)
          }, null, 8, ["data", "aspect-ratio"]),
          _createVNode(CollageTileDefaultLayoutTextAndLink, { data: _unref(thirdItem) }, null, 8, ["data"])
        ], 6))
      : _createCommentVNode("", true)
  ], 2))
}
}

})